export const FrontLoggerSymbol = Symbol.for("FrontShipLoggerSymbol");

export interface IFrontLoggerShipping {
  shipLog: (message: LoggerMsg, level: string, name: string) => void;
}

export type LoggerMsg = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  obj?: Record<string, any>;
  msg: string;
};

export type LogsQueueType = {
  message: LoggerMsg;
  source: string;
  userAgent: string;
};
